import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useGetProductsQuery,
  useDeleteProductMutation,
  useUpdateProductMutation,
} from "slices/beautyApp/productSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import Swal from "sweetalert2";
import { useGetCategoriesQuery } from "slices/beautyApp/categorySlice";

function Products() {
  const naviagte = useNavigate();
  const categoryPage = 1;
  const categoryLimit = 100;
  const categorySearch = "";
  const [categoryId, setCategoryId] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteProductMutation();
  const auth = useSelector((state) => state.auth.auth?.user);
  const [updateProduct] = useUpdateProductMutation();

  const { data, isLoading, refetch } = useGetProductsQuery({
    page,
    limit,
    search,
    catId:categoryId
  });

  const { data: categoriesData, isLoading: categoriesLoading, refetch: categoriesRefetch } = useGetCategoriesQuery({
    categoryPage,
    categoryLimit,
    categorySearch,
  });
  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    {
      display: "Backgroud-Image",
      key: "backgroundImage",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    { display: "Sub Title", key: "sub_title", type: "display" },
    { display: "Service Type", key: "type", type: "display" },
    { display: "Service Cost", key: "servicePrice", type: "display" },
    { display: "Off-Percentage", key: "off_percentage", type: "display" },
    {
      display: "Status",
      key: "isAvailable",
      type: "display",
      render: (row) => (
        <input
          type="checkbox"
          checked={row.isAvailable === true}
          onChange={() => handleStatusToggle(row._id, !row.isAvailable)}
          style={{
            width: "18px",
            height: "18px",
            accentColor: row.isAvailable ? "green" : "red",
            cursor: "pointer",
          }}
        />
      ),
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Services", "edit");
  const canDelete = hasActionAccess(auth, "Beauty App", "Services", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleStatusToggle = async (id, newStatus) => {
    try {
      let response = await updateProduct({
        id,
        body: { isAvailable: newStatus },
      }).unwrap();

      if (response?.success === true) {
        refetch();
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "Error updating status",
      });
    }
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    naviagte(`/beauty-app/products/update-item/${row._id}`);
  };

  const handleAdd = () => {
    naviagte("/beauty-app/products/add-item");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Services", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Item
        </Button>
      )}
      <Tables
        title={"Product Items"}
        handleSearch={handleSearchChange}
        filterData={{data: categoriesData?.data, for: "category", labelKey: "name",onChange: (cityId) => {
        setCategoryId(cityId);      
        refetch();      
        }}}
        totalPages={data?.total}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Products;

